export const OBS_MESSAGE = 'fuckin’ about';
export const SOCIAL = '@hexanal on x / @fredmercy.ca on youtube and instagram';
export const PLEASE_WAIT = false;
export const COLOR_KEY = '#0000ff';
export const FONT_COLOR = '#ffffff';
export const BG_COLOR = '#0000ff';
export const FONT_SIZE = 2.5;
export const WEEKDAY_FORMAT = 'short';
export const DAY_FORMAT = 'numeric';
export const MONTH_FORMAT = 'short';
export const YEAR_FORMAT = 'numeric';
export const FONT_FAMILY = '"Fantasque Sans Mono", monospace';
export const LOWERCASE = true;
